import {Component, inject, OnDestroy, OnInit, ViewEncapsulation, signal, ChangeDetectionStrategy} from "@angular/core"
import {LoadingSpinnerIconComponent} from "@app/common/components/progress"
import {ActionMenuService} from "@app/common/components/viewers/configurator/action-menu/services/action-menu.service"
import {ConfigMenuService} from "@app/common/components/viewers/configurator/config-menu/services/config-menu.service"
import {firstValueFrom, Subject, takeUntil} from "rxjs"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-pdf-download-button",
    templateUrl: "./pdf-download-button.component.html",
    styleUrls: ["./pdf-download-button.component.scss"],
    encapsulation: ViewEncapsulation.ShadowDom,
    imports: [LoadingSpinnerIconComponent],
})
export class PdfDownloadButton implements OnInit, OnDestroy {
    readonly $hidden = signal<boolean>(true)
    readonly $loading = signal(false)

    private _destroyed$ = new Subject<void>()
    private actionMenuService = inject(ActionMenuService)
    private configMenuService = inject(ConfigMenuService)

    ngOnInit() {
        // only show this button once the menu interface is avalaible
        this.configMenuService.interfaceNew$.pipe(takeUntil(this._destroyed$)).subscribe((interfaces) => {
            if (interfaces.length > 0) {
                this.$hidden.set(false)
                this._destroyed$.next()
                this._destroyed$.complete()
            }
        })
    }

    ngOnDestroy() {
        this._destroyed$.next()
        this._destroyed$.complete()
    }

    async onClick() {
        this.$loading.set(true)
        this.actionMenuService.emitPdfDownloadRequested()
        await firstValueFrom(this.actionMenuService.pdfDownloadFinished$())
        this.$loading.set(false)
    }
}
